import * as React from 'react';
import { withRouter } from 'react-router-dom';

@withRouter
class Home extends React.Component {
    render() {
        return (
        	<div className="type--center">
        		<div className="empty-state empty-state--welcome spc--bottom--lrg"></div>
        		<p className="type--medium">Welcome!</p>
        	</div>
    	)
    }
}

export { Home }


// WEBPACK FOOTER //
// ./src/pages/Home.js